module.exports = __webpack_public_path__ + "media/images/logo/instagram-d19627f810a71d40e440ea9a5fc73448.svg";